import React, { FunctionComponent, useCallback, useContext, useEffect } from 'react'
import { NavigationContext } from '@context/NavigationContext'
import { SurveyContext } from '@context/SurveyContext'
import { SurveyMode } from '@reducers/SurveyReducer'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { TabbedPane } from '@components/Survey/TabbedPane/TabbedPane'
import { useTranslation } from 'react-i18next'
import { PredictionContext } from '@context/PredictionContext'
import './Probability.scss'
import { usePreventBackNavigation } from '@hooks/usePreventBackNavigation'
import { categoryHasProbabilityForecasting, getCategory } from '@utils/categoryFlow'


export function ProbabilityPage() {
  usePreventBackNavigation()
  const { t } = useTranslation('Probability')
  const { survey, setMode, setNextStep } = useContext(SurveyContext)
  const { voteProbability, submitVoteProbability, setVoteProbability } = useContext(PredictionContext)
  const { setPrevHandler, setNextHandler } = useContext(NavigationContext)
  const { results, sandboxedResults } = useContext(PredictionContext)

  const handleNextQuestion = () => {
    submitVoteProbability()
    return setNextStep(SurveyStep.Forecasting)
  }

  useEffect(() => {
    setNextHandler(handleNextQuestion)
  }, [voteProbability])

  useEffect(() => {
    if (!categoryHasProbabilityForecasting(getCategory(survey))) {
      setNextStep(SurveyStep.Results)
    }
  }, [survey])

  useEffect(() => {
    setMode(SurveyMode.PROBABILITY)
    setNextHandler(handleNextQuestion)

    return () => {
      setMode(SurveyMode.DEFAULT)
      setPrevHandler(undefined)
      setNextHandler(undefined)
    }
  }, [])

  const tabs = [
    {
      text: t('title'),
    },
  ]

  const isActiveClass = useCallback(
    (value: number) => {
      return voteProbability === value ? 'active' : undefined
    },
    [voteProbability],
  )

  return (
    <TabbedPane tabs={tabs} propClassName="Probability" predictionResults={sandboxedResults ?? results}>
      <p className="question">{t('probabilityQuestion')}</p>
      <div className="content">
        <div className="choices">
          <div className="top">
            <span>{t('notLikely')}</span>
            <span>{t('likely')}</span>
          </div>
          <div className="options">
            {Array.from({ length: 11 }, (_, i) => i).map((item) => (
              <button className={isActiveClass(item)} key={item} onClick={() => setVoteProbability(item)}>
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </TabbedPane>
  )
}

export default ProbabilityPage
